(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDetailController', SSUnidadReceptoraDetailController);

    SSUnidadReceptoraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSUnidadReceptora', 'SSSector', 'SSProyecto'];

    function SSUnidadReceptoraDetailController($scope, $rootScope, $stateParams, previousState, entity, SSUnidadReceptora, SSSector, SSProyecto) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSUnidadReceptoraUpdate', function(event, result) {
            vm.sSUnidadReceptora = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
